import { FilterSelection } from "@amzn/stencil-react-components/filtering";
import { useMemo } from "react";

interface UseDefaultSortingDetectionProps {
  searchQuery: string;
  isBestMatchActive: boolean;
  bestMatchSort: FilterSelection | undefined;
  priceSort: FilterSelection | undefined;
  alphabeticSort: FilterSelection | undefined;
}

export const useDefaultSortingDetection = ({
  searchQuery,
  isBestMatchActive,
  bestMatchSort,
  priceSort,
  alphabeticSort,
}: UseDefaultSortingDetectionProps) => {
  const isAtDefaultSorting = useMemo(() => {
    const hasQuery = searchQuery.trim() !== "";

    if (hasQuery) {
      // Search mode: Default is Best Match (relevance)
      return isBestMatchActive && bestMatchSort === "relevance" && !priceSort && !alphabeticSort;
    } else {
      // Browse mode: Default is Name A to Z (name,asc)
      return alphabeticSort === "name,asc" && !priceSort && !bestMatchSort;
    }
  }, [searchQuery, isBestMatchActive, bestMatchSort, priceSort, alphabeticSort]);

  return { isAtDefaultSorting };
};
